<h1 mat-dialog-title id="idle-dialog-title">Application Timeout Occurred!</h1>
<div mat-dialog-content class="mat-typography">
  You have been idle for the maximum allotted time. You will be redirected.
</div>
